import { render } from "./AdvisoryProgrammDataTable.vue?vue&type=template&id=d77e96dc"
import script from "./AdvisoryProgrammDataTable.vue?vue&type=script&lang=js"
export * from "./AdvisoryProgrammDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__